<template>
    <div class="pop_up_layer find_account" style="display: block" @click=""></div>
    <div class="pop_up pop_detail" id="find_account" style="display: block">
        <button class="close_btn" @click="closeModal">
            <img src="img/close.png" alt="닫기" />
        </button>
        <div class="pop_tit">
            <p>개인정보 수집 및 이용 동의</p>
        </div>
        <div class="content_wrap sign_form">
            <div class="terms_content custom_scroll" v-html="content"></div>

            <div class="checkbox_wrap">
                <label for="chk1">
                    <input id="chk1" type="checkbox" v-model="state.isAgree" ref="isAgree" />
                    <em></em>
                    <span>동의합니다.</span>
                </label>
                <br />
            </div>
            <div class="btn_wrap">
                <button class="submit_btn" :class="{ _gray: !state.isAgree }" :disabled="!state.isAgree" @click="callback">확인</button>
            </div>
        </div>
    </div>
    <!-- 팝업 -->
</template>
<script lang="ts">
    import { onMounted, reactive, watch, onUnmounted } from "@/BaseComponent";

    export default {
        props: {
            isShow: {
                type: Boolean,
                default: false,
            },
            title: {
                type: String,
                default: "",
            },
            content: {
                type: String,
                default: "",
            },
        },
        emits: ["close"],
        setup(props: any, { emit }: any) {
            const state = reactive({
                isShow: false as boolean,
                isAgree: false as boolean,
            });

            onMounted(() => {
                state.isShow = props.isShow;

                document.body.style.overflow = "hidden";
            });

            onUnmounted(() => {
                document.body.style.overflow = "";
            });

            const closeModal = () => {
                emit("close");
            };

            const callback = () => {
                emit("close", state.isAgree);
            };
            return { state, closeModal, callback, props };
        },
    };
</script>

<style scoped>
    .checkbox_wrap {
        margin-top: 15px;
    }
</style>
